<template>
    <div class="dashboard__view">
        <div @click="$router.go(-1)" class="page__nav">
          <div class="page__nav__icon">
            <svg
                fill="none"
                height="16"
                viewBox="0 0 19 16"
                width="19"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M19 7L4.92969 7L9.5 2.42969L8 0.929687L0.929687 8L8 15.0703L9.5 13.5703L4.92969 9L19 9L19 7Z"
                  fill="#655D79"
              />
            </svg>
          </div>
          <div class="page__nav__text">Payout Details</div>
        </div>
        <div class="details transaction">
            <div class="row w-100">
                <div class="col-md-6" v-if="!payout || payout.loading || loading">
                    <div class="details__card w-100">
                        <div class="details__card__container p-5">
                            <div class="my-5">
                                <ListLoader></ListLoader>
                            </div>
                            <div class="my-5">
                                <ListLoader></ListLoader>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6" v-else-if="payout.id">
                    <div style="display: flex; align-items: center; gap: 12px; margin-top: 20px; margin-bottom: 20px; width: 100%;">
                        <input type="text" style="width: 100%; border: 1px solid #dfe2e5; height: 40px; border-radius: 8px; outline: none; padding: 12px;" v-model="newsessionid">
                        <div class="confirm_btn" style="width: fit-content; height: 40px; background-color: #E00B5B; color: white;" @click="updateSessionId">Update session id</div>
                    </div>
                    <div class="details__card__container">
                        <div class="details__card__header pl-3 pr-0">
                          <div class="row align-items-center m-0">
                                <div class="col-auto p-0">
                                    <StatusIndicator :type="payout.transaction_status" />
                                </div>
                                <div class="col-auto p-0">
                                    <h1>{{ payout.payout_reference }}</h1>
                                </div>
                            </div>
                        </div>
                        <div class="details__card__item border-none pt-2">
                            <div class="details__card__item__left">
                                <div class="details__card__item__label">Amount</div>
                                <div class="details__card__item__value">
                                    <h1>&#8358;&nbsp;{{ payout.amount }}</h1>
                                </div>
                            </div>
                            <div class="details__card__item__right">
                            <div class="details__card__item__label">Business name</div>
                            <div class="details__card__item__value">
                              {{ payout.merchant_business_name || payout.merchant_name }}
                            </div>
                          </div>
                        </div>

                        <div class="details__card__item">
                            <div class="details__card__item__left">
                                <div class="details__card__item__label">
                                    Destination Bank
                                </div>
                                <div class="details__card__item__value uppercase">
                                    {{  payout.bankName }} <br />
                                    {{ payout.beneficiary_nuban }}
                                </div>
                            </div>

                            <div class="details__card__item__right">
                                <div class="details__card__item__label">
                                    Beneficiary
                                </div>
                                <div class="details__card__item__value">
                                    {{ payout.beneficiary_account_name }}
                                </div>
                            </div>
                        </div>

                        <div class="details__card__item">
                            <div class="details__card__item__left">
                                <div class="details__card__item__label">Narration</div>
                                <div class="details__card__item__value uppercase">
                                    {{ payout.narration }}
                                </div>
                            </div>
                        </div>
                        <div class="details__card__item">
                            <div class="details__card__item__left">
                                <div class="details__card__item__label">Transaction Date</div>
                                <div class="details__card__item__value">
                                    {{ payout.transactionDate }}
                                </div>
                            </div>


                            <div class="details__card__item__right">
                                <div class="details__card__item__label">
                                    Initiation Date
                                </div>
                                <div class="details__card__item__value">
                                    {{ payout.initiationDate }}
                                </div>
                            </div>
                        </div>
                        <div class="details__card__item">
                            <div class="details__card__item__left">
                                <div class="details__card__item__label">Status Description</div>
                                <div class="details__card__item__value">
                                    {{ payout.user_message }}
                                </div>
                            </div>
                        </div>
                      <div class="details__card__item" v-if="payout.transaction_status === 'FAILED'
                            ">
                        <button
                            class="btn btn--primary text-primary"
                            @click="retryProcess(payout.unique_reference)"
                            style="display: flex;align-items: center;"
                        >
                          <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                                d="M6 19V6.55556C6 6.143 6.18061 5.74733 6.5021 5.45561C6.82359 5.16389 7.25963 5 7.71429 5H16.2857C16.7404 5 17.1764 5.16389 17.4979 5.45561C17.8194 5.74733 18 6.143 18 6.55556V19L15.4286 17.4444L13.7143 19L12 17.4444L10.2857 19L8.57143 17.4444L6 19Z"
                                stroke="#ffffff"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M13.7142 13.5556V12.0001C13.7142 11.5875 13.5637 11.1918 13.2958 10.9001C13.0279 10.6084 12.6645 10.4445 12.2856 10.4445H9.42847M9.42847 10.4445L10.857 8.65551M9.42847 10.4445L10.857 12.0001"
                                stroke="#ffffff"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                          </svg>
                          Retry Payout
                        </button>
                      </div>

                    </div>
                </div>

                <div class="col-md-6" v-if="!audit">
                    <div class="details__card w-100">
                        <div class="details__card__container">
                            <div class="details__trail w-100 m-0">
                                <div class="details__trail__header">Payout Logs</div>
                                <BulletListLoader></BulletListLoader>
                                <BulletListLoader></BulletListLoader>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6" v-else-if="audit">
                    <div class="details__card w-100">
                        <div class="details__card__container p-0">
                            <div class="details__trail w-100 m-0">
                                <div class="details__trail__header">
                                    <div class="row justify-content-center align-items-center">
                                        <div class="col">
                                            Payout Logs
                                        </div>
                                        <div class="col-auto text-right" v-if="showCallbackRetry">
                                            <button
                                                    class="btn btn--white text-primary"
                                                    @click="resendCallback(payout.unique_reference)"
                                                    :disabled="disableResendBtn"
                                            >
                                                <div
                                                        class="row m-0 justify-content-center align-items-center"
                                                >
                                                    <div class="col-auto p-0">
                                                        <svg
                                                                width="24"
                                                                height="24"
                                                                viewBox="0 0 24 24"
                                                                fill="none"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <path
                                                                    d="M6 19V6.55556C6 6.143 6.18061 5.74733 6.5021 5.45561C6.82359 5.16389 7.25963 5 7.71429 5H16.2857C16.7404 5 17.1764 5.16389 17.4979 5.45561C17.8194 5.74733 18 6.143 18 6.55556V19L15.4286 17.4444L13.7143 19L12 17.4444L10.2857 19L8.57143 17.4444L6 19Z"
                                                                    stroke="#17A0FB"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                            />
                                                            <path
                                                                    d="M13.7142 13.5556V12.0001C13.7142 11.5875 13.5637 11.1918 13.2958 10.9001C13.0279 10.6084 12.6645 10.4445 12.2856 10.4445H9.42847M9.42847 10.4445L10.857 8.65551M9.42847 10.4445L10.857 12.0001"
                                                                    stroke="#17A0FB"
                                                                    stroke-linecap="round"
                                                                    stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <div class="col">
                                                        Resend Callback
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="timeline p-4 block mb-4">
                                    <div class="tl-item active">
                                        <div class="tl-dot b-warning"></div>
                                        <div class="tl-content">
                                            <div class="h4">Payout initiated</div>
                                            <div class="tl-date text-muted mt-1 h5">
                                                {{ moment(payout.createdAt).format("llll") }}
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                            class="tl-item active"
                                            v-for="item in audit"
                                            :key="item.timestamp"
                                    >
                                        <div class="tl-dot b-primary" v-if="item.entity_id"></div>
                                        <div class="tl-content" v-if="item.entity_id">
                                            <div class="h4">{{ item.entity_comment }}</div>
                                            <div class="tl-date text-muted mt-1 h5">
                                                {{ moment(item.timestamp).format("llll") }}
                                            </div>
                                        </div>
                                        <div class="tl-dot b-primary" v-if="item.callback_id"></div>
                                        <div class="tl-content" v-if="item.callback_id">
                                            <div class="h4">
                                                Callback sent Response code: {{ item.response_code }}
                                            </div>
                                            <div class="tl-date text-muted mt-1 h5">
                                                {{ moment(item.trigger_time).format("llll") }}
                                            </div>
                                            <json-tree
                                                    :raw="item.callback_payload"
                                                    :level="0"
                                            ></json-tree>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, computed } from '@vue/composition-api'

import StatusIndicator from "@/components/status-indicator.vue";
import _ from "lodash";
import {
	ContentLoader,
	ListLoader,
	BulletListLoader,
} from "vue-content-loader";

export default {
  components: {
	  StatusIndicator,
	  ContentLoader,
	  ListLoader,
	  BulletListLoader,
  },
  setup(props, { root }) {
    const store = root.$store;
    onBeforeMount(() => {
			store.dispatch("getSinglePayoutDetails", { ...root.$route.params });
		})
  },

	created() {
		this.fetchAudit(this.payout.unique_reference);
	},

	data() {
		return {
			audit: "",
			showCallbackRetry: false,
            disableResendBtn: false,
            newsessionid: "",
            loading: false
		};
	},
	methods: {
		moment: window.moment,
		handleRedirect() {
			root.$router.go(-1);
		},
		fetchAudit(value) {
			this.$http.get(`dashboard/audits?entity_id=${value}`).then((response) => {
				this.audit = response.body.data.audits;
				this.showCallbackRetry = true;
			});
		},
        retryProcess(){
            alert('Sorry, not implemented yet waiting for api')
        },
        resendCallback(value) {
        this.disableResendBtn = true;
        this.$http.post(
            `admin/ping/${value}`
        ).then(() => {
            this.$notify({
            group: "notifications-default",
            type: "success text-white",
            title: "Success",
            text: "Webhooks sent",
            });
            this.disableResendBtn = false;
        }).catch(() => this.disableResendBtn = false);
        },
        async updateSessionId() {
            try {
                this.loading = true;
                const requestBody = {
                    "transactionIds": [this.payout.id],
                    "sessionIds": [this.newsessionid],
                    "transactionType": "COLLECTION"
                };
                const response = await this.$http.post("admin/collection/update", requestBody);
                this.loading = false;
                if(response.body.status || response.status == 200){
                    this.$notify({
                        group: "notifications-default",
                        type: "success text-white",
                        title: "Success",
                        text: response.body.data.result,
                    });
                }
                this.newsessionid = "";
            } catch (error) {
                this.loading = false;
                this.$notify({
                    group: "notifications-default",
                    type: "error text-white",
                    title: "Error",
                    text: "Error updating payout",
                });
            }
        },
        
  },
	computed: {
		payout() {
			let a = this.$store.getters.getSinglePayoutDetails;
			this.fetchAudit(a.unique_reference);
			return a;
		},
		banks() {
			return this.$store.state.bankList;
		},
	},
}

</script>

<style>
    .woven-strip {
        position: absolute;
        left: 0;
    }
    .details__card__container {
        box-shadow: none !important;
        border-radius: 4px;
        border: 0;
    }
    .details.transaction h1 {
        color: #261940 !important;
        font-size: 24px !important;
        font-weight: 400 !important;
    }
    .details__card__item {
        border-top: 1px solid rgb(235 240 244 / 50%);
    }
    .details.transaction .details__card__header {
        border: 0 !important;
    }
    .details.transaction .details__card__container {
        padding: 1rem;
    }
    .border-none {
        border: 0 !important;
    }

    .w-32 {
        width: 32px !important;
        height: 32px !important;
        font-size: 0.85em;
    }

    .tl-item .avatar {
        z-index: 2;
    }

    .timeline {
        position: relative;
        border-color: rgba(160, 175, 185, 0.15);
        padding: 0;
        margin: 0;
    }
    .tl-item {
        border-radius: 3px;
        position: relative;
        display: -ms-flexbox;
        display: flex;
    }

    .tl-item > * {
        padding: 10px;
    }

    .tl-item .avatar {
        z-index: 2;
    }

    .tl-item:last-child .tl-dot:after {
        display: none;
    }

    .tl-item:last-child .tl-dot:after {
        display: none;
    }

    .tl-dot {
        position: relative;
        border-color: rgba(160, 175, 185, 0.15);
    }

    .tl-dot:after,
    .tl-dot:before {
        content: "";
        position: absolute;
        border-color: inherit;
        border-width: 2px;
        border-style: solid;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        top: 15px;
        left: 50%;
        transform: translateX(-50%);
    }

    .tl-dot:after {
        width: 0;
        height: auto;
        top: 25px;
        bottom: -15px;
        border-right-width: 0;
        border-top-width: 0;
        border-bottom-width: 0;
        border-radius: 0;
    }

    .tl-item.active .tl-dot.b-primary:before {
        background-color: rgba(21, 206, 154, 0.7);
    }

    .tl-item.active .tl-dot.b-warning:before {
        background-color: rgba(255, 175, 11, 1);
    }

    .tl-item.active .tl-dot.b-danger:before {
        background-color: rgba(198, 16, 16, 0.7);
    }
    /* .tl-item.active .tl-dot:before {
        background-color: #448bff;
    } */
    .tl-dot {
        position: relative;
        border-color: rgba(160, 175, 185, 0.15);
    }

    .tl-dot:after,
    .tl-dot:before {
        content: "";
        position: absolute;
        border-color: inherit;
        border-width: 2px;
        border-style: solid;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        top: 15px;
        left: 50%;
        transform: translateX(-50%);
    }

    .tl-dot:after {
        width: 0;
        height: auto;
        top: 25px;
        bottom: -15px;
        border-right-width: 0;
        border-top-width: 0;
        border-bottom-width: 0;
        border-radius: 0;
    }

    .tl-content p:last-child {
        margin-bottom: 0;
    }

    .tl-date {
        font-size: 0.85em;
        margin-top: 2px;
        min-width: 100px;
    }
    .h4 {
        font-size: 16px;
    }
    .h5 {
        font-size: 14px;
    }
    .w-100 {
        width: 100%;
    }
    .json-tree-root {
        min-width: 400px;
        max-width: 400px;
    }
    .confirm_btn {
  font-family: Lato;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  background-color: white;
  border-radius: 6px;
  border: 1px solid #e00b5b;
  box-sizing: border-box;
  color: #e00b5b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  width: fit-content;
  padding-left: 16px;
  padding-right: 16px;
  text-wrap: nowrap;
}
</style>
